var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M107.1 735.5L457 221c18.6-31.5 59.2-42.1 90.7-23.5 9.8 5.8 17.9 13.9 23.7 23.8l347.2 514.4c18.4 31.6 7.8 72.2-23.8 90.6-10.2 5.9-21.8 9.1-33.6 9h-697c-36.6 0-66.3-29.7-66.2-66.3 0-11.8 3.2-23.4 9.1-33.5z"}})}
var staticRenderFns = []

export { render, staticRenderFns }